const actions = {
  saveTabData({ commit }, { tabName, data }) {
    commit("setTabData", { tabName, data });
  },

  resetTabData({ commit }, tabName) {
    commit("resetTabData", tabName);
  },
};

export default actions; 